(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const currency = window.Shopify?.currency?.active || "PLN";
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || "pl-PL", { style: "currency", currency }).format((cents || 0) / 100);
  const escapeHtml = (value = "") => String(value).replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }[character]));

  function initCountdown() {
    $$('[data-countdown]').forEach((timer) => {
      let remaining = Number(timer.dataset.hours || 0) * 3600 + Number(timer.dataset.minutes || 0) * 60 + Number(timer.dataset.seconds || 0);
      const initial = Math.max(remaining, 1);
      const render = () => {
        $('[data-hours]', timer).textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        $('[data-minutes]', timer).textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
        $('[data-seconds]', timer).textContent = String(remaining % 60).padStart(2, '0');
        remaining = remaining > 0 ? remaining - 1 : initial;
      };
      render();
      window.setInterval(render, 1000);
    });
  }

  function initDrawers() {
    const menuLayer = $('[data-menu-layer]');
    const cartLayer = $('[data-cart-layer]');
    const toggle = (layer, open) => {
      if (!layer) return;
      layer.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) $('button, a', layer)?.focus();
    };
    $('[data-open-menu]')?.addEventListener('click', () => toggle(menuLayer, true));
    $('[data-close-menu]')?.addEventListener('click', () => toggle(menuLayer, false));
    menuLayer?.addEventListener('click', (event) => { if (event.target === menuLayer) toggle(menuLayer, false); });
    $$('a', menuLayer || document.createElement('div')).forEach((link) => link.addEventListener('click', () => toggle(menuLayer, false)));
    $$('[data-open-cart]').forEach((button) => button.addEventListener('click', async () => { await refreshCart(); toggle(cartLayer, true); }));
    $('[data-close-cart]')?.addEventListener('click', () => toggle(cartLayer, false));
    cartLayer?.addEventListener('click', (event) => { if (event.target === cartLayer) toggle(cartLayer, false); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { toggle(menuLayer, false); toggle(cartLayer, false); } });
    window.DermeloOpenCart = async () => { await refreshCart(); toggle(cartLayer, true); };
  }

  function initAccordions() {
    $$('[data-accordion-trigger]').forEach((button) => button.addEventListener('click', () => {
      const item = button.closest('.accordion');
      const content = $('.accordion__content', item);
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      item.classList.toggle('is-open', !open);
      content.hidden = open;
    }));
  }

  function initProduct() {
    const section = $('[data-product-section]');
    if (!section) return;
    const form = $('[data-product-form]', section);
    const variantInput = $('[data-variant-input]', section);
    const quantityInput = $('[data-quantity-input]', section);
    const addLabel = $('[data-add-label]', section);
    const sticky = $('[data-sticky-cart]');
    const updateBundle = (choice) => {
      if (!choice) return;
      $$('.bundle-card', section).forEach((card) => card.classList.toggle('is-selected', card.contains(choice)));
      variantInput.value = choice.dataset.variantId || '';
      quantityInput.value = '1';
      addLabel.textContent = `Dodaj do koszyka — ${choice.dataset.price || ''}`;
      $$('[data-gift]', section).forEach((gift) => {
        const unlocked = Number(choice.dataset.quantity || 1) >= Number(gift.dataset.gift || 99);
        gift.classList.toggle('gift-card--active', unlocked);
        const small = $('small', gift);
        if (small) small.textContent = unlocked ? 'Odblokowano' : `Wybierz ${gift.dataset.gift} pakiety`;
      });
      if (sticky) {
        $('[data-sticky-title]', sticky).textContent = section.dataset.productTitle;
        $('[data-sticky-price]', sticky).textContent = choice.dataset.price || '';
        $('[data-sticky-compare]', sticky).textContent = choice.dataset.compare || '';
      }
    };
    $$('[data-bundle-choice]', section).forEach((choice) => choice.addEventListener('change', () => updateBundle(choice)));
    updateBundle($('[data-bundle-choice]:checked', section));

    $$('[data-gallery-thumb]', section).forEach((thumb) => thumb.addEventListener('click', () => {
      const main = $('[data-gallery-main]', section);
      if (!main) return;
      main.src = thumb.dataset.imageUrl;
      main.alt = thumb.dataset.imageAlt || '';
      $$('[data-gallery-thumb]', section).forEach((item) => item.classList.toggle('is-active', item === thumb));
    }));

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const error = $('[data-product-error]', section);
      const button = $('button[type="submit"]', form);
      if (!variantInput.value) { error.textContent = 'Najpierw wybierz produkt i jego wariant w edytorze motywu.'; error.classList.add('is-visible'); return; }
      button.disabled = true;
      error.classList.remove('is-visible');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error((await response.json()).description || 'Nie udało się dodać produktu.');
        await refreshCart();
        await window.DermeloOpenCart?.();
      } catch (requestError) {
        error.textContent = requestError.message || 'Nie udało się dodać produktu do koszyka.';
        error.classList.add('is-visible');
      } finally { button.disabled = false; }
    });

    $('[data-sticky-add]')?.addEventListener('click', () => form?.requestSubmit());
    if (sticky) {
      const showSticky = () => { sticky.hidden = window.scrollY < Math.min(620, section.offsetHeight * .45); };
      showSticky(); window.addEventListener('scroll', showSticky, { passive: true });
    }
  }

  async function refreshCart() {
    const content = $('[data-cart-content]');
    if (!content) return;
    try {
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { 'Accept': 'application/json' } }).then((response) => response.json());
      $$('[data-header-cart-count]').forEach((badge) => { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
      $('[data-cart-count]').textContent = `${cart.item_count} szt.`;
      if (!cart.item_count) {
        content.innerHTML = `<div class="empty-cart"><svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 8h12l1 12H5L6 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/></svg><h2>Twój koszyk jest pusty</h2><button type="button" data-close-empty>Wróć do zakupów</button></div>`;
        $('[data-close-empty]', content)?.addEventListener('click', () => $('[data-close-cart]')?.click());
        return;
      }
      content.innerHTML = `<div class="cart-content"><div class="reserve">Produkty w koszyku są gotowe do zamówienia</div><div class="cart-drawer-items">${cart.items.map((item) => `<article><img src="${escapeHtml(item.featured_image?.url || '')}" alt="${escapeHtml(item.product_title)}"><div><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(item.variant_title || '')}</p><b>${formatMoney(item.final_line_price)}</b><div class="qty"><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}">+</button></div><br><button type="button" class="cart-line-remove" data-cart-change="${escapeHtml(item.key)}" data-quantity="0">Usuń</button></div></article>`).join('')}</div><div class="cart-total"><span>Suma</span><strong>${formatMoney(cart.total_price)}</strong></div><a class="checkout-button" href="${window.Shopify.routes.root}checkout">Przejdź do kasy</a><small class="cart-note">Bezpieczne płatności</small></div>`;
      $$('[data-cart-change]', content).forEach((button) => button.addEventListener('click', async () => {
        button.disabled = true;
        await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: button.dataset.cartChange, quantity: Number(button.dataset.quantity) }) });
        await refreshCart();
      }));
    } catch { content.innerHTML = `<div class="empty-cart"><h2>Nie udało się wczytać koszyka</h2><p>Odśwież stronę i spróbuj ponownie.</p></div>`; }
  }

  document.addEventListener('DOMContentLoaded', () => { initCountdown(); initDrawers(); initAccordions(); initProduct(); });
})();
